export const name = "ST_LINESUBSTRING";
export const summary = `Gets a segment of a single linestring at a specific starting and ending fraction.`;
export const reference = `
## ST_LINESUBSTRING

Gets a segment of a single linestring at a specific starting and ending fraction.

\`\`\`
ST_LINESUBSTRING(linestring_geography, start_fraction, end_fraction);
\`\`\`

### Description

Gets a segment of a linestring at a specific starting and ending fraction.


### Definitions

- \`linestring_geography\`: The LineString \`GEOGRAPHY\` value that represents the linestring from which to extract a segment.
- \`start_fraction\`: \`FLOAT64\` value that represents the starting fraction of the total length of \`linestring_geography\`. This must be an inclusive value between 0 and 1 (0-100%).
- \`end_fraction\`: \`FLOAT64\` value that represents the ending fraction of the total length of \`linestring_geography\`. This must be an inclusive value between 0 and 1 (0-100%).


### Details

\`end_fraction\` must be greater than or equal to \`start_fraction\`.

If \`start_fraction\` and \`end_fraction\` are equal, a linestring with only one point is produced.


### Return type

- LineString \`GEOGRAPHY\` if the resulting geography has more than one point.
- Point \`GEOGRAPHY\` if the resulting geography has only one point.


### Example

The following query returns the second half of the linestring:



\`\`\`
WITH data AS (
  SELECT ST_GEOGFROMTEXT('LINESTRING(20 70, 70 60, 10 70, 70 70)') AS geo1
)
SELECT ST_LINESUBSTRING(geo1, 0.5, 1) AS segment
FROM data;

/*-------------------------------------------------------------+
 | segment |
 +-------------------------------------------------------------+
 | LINESTRING(49.4760661523471 67.2419539103851, 10 70, 70 70) |
 +-------------------------------------------------------------*/
\`\`\`

The following query returns a linestring that only contains one point:



\`\`\`
WITH data AS (
  SELECT ST_GEOGFROMTEXT('LINESTRING(20 70, 70 60, 10 70, 70 70)') AS geo1
)
SELECT ST_LINESUBSTRING(geo1, 0.5, 0.5) AS segment
FROM data;

/*------------------------------------------+
 | segment |
 +------------------------------------------+
 | POINT(49.4760661523471 67.2419539103851) |
 +------------------------------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
